<template>
  <div />
</template>

<script setup>

  import { useNuxtApp } from 'nuxt/app';
  import { onBeforeUnmount, onMounted, useId } from 'vue';
  import { OPTANON_CATEGORY_4, OptanonCategories } from '~~/common/config/OptanonCategoryConfig.js';

  const ID_ARUKERESO_TRACKING = 'arukereso-tracking';
  const scriptId = `${ID_ARUKERESO_TRACKING}_${useId()}`;

  const props = defineProps({
    page: {
      type: String,
      required: true,
      validate: (value) => ['product_detail', 'thank_you'].includes(value),
    },
    additionalContent: {
      type: String,
      default: '',
    },
  });

  onMounted(() => {
    const {
      $awAcceptedCookieLevel,
      $awMergedConfig,
    } = useNuxtApp();
    const arukeresoUrl = $awMergedConfig.arukeresoUrl;
    if (arukeresoUrl) {
      const arukeresoScriptTag = document.createElement('script');
      arukeresoScriptTag.type = $awAcceptedCookieLevel[OPTANON_CATEGORY_4] ? 'text/javascript' : 'text/plain';
      arukeresoScriptTag.setAttribute('class', OptanonCategories[OPTANON_CATEGORY_4]);
      arukeresoScriptTag.setAttribute('id', scriptId);
      arukeresoScriptTag.innerHTML = `(function(t, r, a, c, k, i, n, g) {t['ROIDataObject'] = k;
t[k]=t[k]||function(){(t[k].q=t[k].q||[]).push(arguments)},t[k].c=i;n=r.createElement(a),
g=r.getElementsByTagName(a)[0];n.async=1;n.src=c;g.parentNode.insertBefore(n,g)
})(window, document, 'script', '${arukeresoUrl}${props.page}', 'arukereso', 'hu');${props.additionalContent}`;
      document.body.appendChild(arukeresoScriptTag);
    }
  });

  onBeforeUnmount(() => {
    const scriptTag = document.getElementById(scriptId);
    if (scriptTag) {
      scriptTag.remove();
    }
  });

</script>
